<template>
  <div>
    <el-alert
        v-if="loadingThermogram"
        title="Данные термограмм все еще загружаются..."
        type="warning"
        :closable="false"
        show-icon>
    </el-alert>

    <user-info :visit="visit" :loading="loadingDevices"/>

    <div class="header">
      <h2 class="header__title">Просмотр данных с приборов и добавление комментариев</h2>
      <el-button type="primary" icon="el-icon-picture-outline" @click="showGallery()"></el-button>
    </div>

    <device-item
        :conclusionEdit="conclusionEditable()"
        :device="conclusion"
        :visitId="visitId"
        :conclusion="true"
        :conclusionComment="getDocComment"
        @openHeadMap="openHeadMap"
        @openFile="openFile"
    ></device-item>

    <div v-loading="loadingDevices" class="box-card">

      <el-card class="box-card" v-loading="loadingDevices">
        <div class="devices" v-if="devices">

          <device-item
              v-for="device in devices.devices"
              :key="device.id"
              :device="device"
              :visitId="visitId"
              :comment="devices.comments"
              :loadingThermogram="loadingThermogram"
              @openHeadMap="openHeadMap"
              @openFile="openFile"
          ></device-item>

          <card :loading="loadingPoll" :maxWidth="'auto'" :width="'100%'">
            <el-tabs :stretch="true">
              <el-tab-pane
                  :label="item.title"
                  :name="item.id.toString()"
                  v-for="item of dataPoll.poll"
                  :key="item.id"
                  style="pointer-events: none"
              >
                <el-checkbox-group v-model="pollAnswers[item.id]">
                  <el-checkbox-button
                      v-for="tag in item.tag"
                      :label="tag.id"
                      :key="tag.id"
                  >{{ tag.text }}
                  </el-checkbox-button>
                </el-checkbox-group>
              </el-tab-pane>
            </el-tabs>
          </card>

          <card
              :loading="loadingQuestionnaire"
              :maxWidth="'auto'"
              :width="'100%'"
          >
            <div slot="title">Описание пациента</div>

            <div
                :label="item.title"
                :name="item.id.toString()"
                v-for="item of questionnaire"
                :key="item.id"
                style="pointer-events: none"
            >
              <el-checkbox-group v-model="pollQuestionnaire">
                <el-checkbox-button
                    v-for="tag in item.questions"
                    :label="tag.id"
                    :key="tag.id"
                >{{ tag.text }}
                </el-checkbox-button>
              </el-checkbox-group>
            </div>
          </card>

          <organism-systems v-if="visit" :user="visit.user"
                            :human-system-health="devices.human_system_health"/>

          <choose-complex-exercise v-if="!extendedConclusionIsGenerated"
                                   :complexes="devices.available_complex_exercises"/>


        </div>
      </el-card>

    </div>

    <heat-map
        :results="devices.results"
        :markup="devices.deviation_markup"
        :comments="devices.comments"
        :visible="showModalHeatMap"
        @close="showModalHeatMap = false"
        :diagnosticData="diagnosticData"
    ></heat-map>

    <template v-if="devices.devices">
      <photo-gallery
          :devices="devices.devices"
          :visible="isOpenModalViewImage"
          @close="isOpenModalViewImage = false"/>

    </template>

    <file-viewer
        :file="showFile"
        :visible="isVisibleFileViewer"
        @close="isVisibleFileViewer = false"
    />

  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex"
import Vue from "vue"
import VueMask from "v-mask"
import HeatMap from "@/components/HeatMap/Modal"
import DeviceItem from "@/components/visit/DeviceItem"
import moment from "moment"

import Card from "@/components/elements/Card.vue"
import UserInfo from "@/components/visit/UserInfo.vue"
import PhotoGallery from "@/views/cpanel/visit/modal/PhotoGallery"
import FileViewer from "@/views/cpanel/visit/modal/FileViewer"
import OrganismSystems from "@/views/cpanel/visit/OrganismSystems"
import ChooseComplexExercise from "@/components/visit/conclusion/ChooseComplexExercise"

Vue.use(VueMask)

export default {
  name: "Device",
  components: {ChooseComplexExercise, PhotoGallery, FileViewer, HeatMap, DeviceItem, Card, UserInfo, OrganismSystems},
  data: function () {
    return {
      card: [
        {
          title: "Приборы",
          id: 1,
        },
      ],
      loadingDevices: false,
      extendedConclusionIsGenerated: false,
      showModalHeatMap: false,
      diagnosticData: {},
      deviceDeviationField: null,
      selectPhoto: "",
      conclusion: {
        title: "Комментарий от оператора",
      },
      loadingPoll: true,
      dataPoll: [],
      tabPoll: "1",
      poll: {
        type: [],
      },
      pollAnswers: [],
      pollQuestionnaire: [],
      questionnaire: null,
      loadingQuestionnaire: true,
      isOpenModalViewImage: false,
      showFile: {},
      isVisibleFileViewer: false,
    }
  },
  computed: {
    ...mapGetters({
      visitStage: "visit/data",
      devices: "visit/getDevices",
      loading: "visit/loading",
      loadingThermogram: "thermogram/loading",
    }),
    visitId() {
      return this.$route.params.id;
    },
    visit() {
      return this.$route.params.visit;
    },
    getDocComment () {
        return this.devices?.visit?.doc_comment || ''
    }
  },
  created() {
    if (this.visitStage) this.loadLogic()
    else this.$router.push({name: "visit.list"})

    this.setStageVisit(4)

    if (this.visit && this.visit.extended_conclusion_is_generated) {

      this.extendedConclusionIsGenerated = true
      this.loadingDevices = true

      this.loadConclusion({visitId: this.visitId, data: {}}).then(() => {
        this.$notify.success({
          title: "Успешно",
          message: "Заключение загружено",
        })
      }).catch((response) => {
        this.$notify.error({
          title: "Ошибка загрузки заключения",
          message: response.response.data.message
        })
      }).finally(() => {
        this.loadingDevices = false
      })

    }

  },
  filters: {},
  methods: {
    ...mapActions({
      setVisit: "visit/SET_DATA",
      setStageVisit: "visit/SET_STAGE",
      loadVisitData: "visit/LOAD_VISIT_DATA",
      loadConclusion: "visit/GENERATE_CONCLUSION",
    }),
    loadLogic() {
      this.loadDevices();
    },
    openHeadMap(diagnosticData) {
      this.pageLoading(true)

      this.showModalHeatMap = true
      this.diagnosticData = diagnosticData

      this.pageLoading(false)
    },
    openFile(file) {
      this.showFile = file
      this.isVisibleFileViewer = true
    },
    loadDevices() {
      this.loadingDevices = false
      // this.loadVisitData(this.visitId)

      this.loadPolls()
    },
    loadPolls() {
      this.loadingPoll = true
      this.$api.visit
          .getPoll(this.visitId)
          .then((response) => {
            this.dataPoll = response.data

            let poll = {}
            response.data.poll.forEach((i) => {
              poll[i.id] = [];
            })

            response.data.answer.forEach((i) => {
              poll[1].push(i.id);
            })

            this.pollAnswers = poll
            this.loadQuestionnaire()
          })
          .catch((response) => {
            this.$notify.error({
              title: "Ошибка загрузки тагетированных анкет 😕",
              message: response.response.data.message,
            });
          })
          .finally(() => {
            this.loadingPoll = false
          });
    },
    conclusionEditable() {
      let datePlusIndent = moment().subtract('hours', 3)

      return moment(datePlusIndent).isAfter(this.visit?.date_end)
    },
    loadQuestionnaire() {
      let params = {
        params: {
          search: 120,
        },
      }
      this.loadingQuestionnaire = true

      this.$api.visit
          .getQuestionnaire(this.visitId, params)
          .then((response) => {
            this.questionnaire = response.data

            let questionnaire = [];
            response.data[0].user_questionnaire.question_answer.forEach((e) => {
              if (e.answer_bool)
                  // pollQuestionnaire
                questionnaire.push(e.question_id)
            });

            this.pollQuestionnaire = questionnaire
          })
          .catch(() => {
          })
          .finally(() => {
            this.loadingQuestionnaire = false
          })
    },

    showGallery() {
      this.isOpenModalViewImage = true
    },

  },
}
</script>

<style scoped lang="scss">
.box-cards {
  @media screen and (min-width: 1000px) {
    display: flex;
    align-items: flex-start;
  }
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;

  margin: 20px 0;

  &__title {
    font-weight: 500;
    font-size: 13px;

    line-height: 1;
    color: #111;
    padding: 0;
    margin: 0;
  }
}

.box-card {
  max-width: 1560px;
  background: #fff;
  border: 0;
  box-shadow: none;
  background: none;
}

.device-box {
  background: #fff;
  border-radius: 6px;
  padding: 10px;
  margin: 12px 0;
}

.error-load {
  margin: 0 auto;
  text-align: center;
}

.devices {
  margin: 0 auto;
  padding-top: 2px;

  &__item {
    background: #fff;
    border: #fff;
    color: #606266;
    transition: 0.3s;
    padding: 20px;
    max-width: 90%;
    margin-top: 10px;

    border-radius: 4px;
    overflow: hidden;

  }

}

//
//.box-card /deep/ .el-card__body {
//  padding: 0 0 10px 0;
//}


//.tabs {
//  margin-top: 16px;
//
//  /deep/ .el-tabs__item.is-active {
//    color: #111;
//  }
//
//  /deep/ .el-tabs__active-bar {
//    background-color: #111;
//  }
//
//  /deep/ .el-tabs__item {
//    color: #8E8E93;
//  }
//}
</style>
